import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './utils/filter'
import store from './store/';
import VuePageTransition from 'vue-page-transition'
import '@babel/polyfill'
import {
  Button,
  Layout,
  Breadcrumb,
  Row,
  Col,
  Dropdown,
  Select,
  Icon,
  Tooltip,
  Form,
  Input,
  Table,
  Modal,
  Menu,
  Spin,
  message,
  ConfigProvider,
  LocaleProvider
} from 'ant-design-vue';
Vue.config.productionTip = false
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$message = message;
Vue.use(ConfigProvider)
  .use(LocaleProvider)
  .use(Button)
  .use(Layout)
  .use(Row)
  .use(Col)
  .use(Breadcrumb)
  .use(Dropdown)
  .use(Select)
  .use(Icon)
  .use(Form)
  .use(Input)
  .use(Tooltip)
  .use(Table)
  .use(Modal)
  .use(Menu)
  .use(Spin)
  .use(VuePageTransition)
export const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
